import * as mobx from 'mobx';
import { emailListValidator } from '../../../modules/validators';
import { COMPLINACE_EMAIL_MAX_EMAILS_AMOUNT } from '../../../constants/common.constants';
import { COMPLIANCE_EMAIL_DATA_UPDATED, EMAIL_ADDRESSES_IS_REQUIRED, ENTER_MAXIMUM_TEN_EMAILS } from './compliance-emails.text';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { MessageDescriptor } from 'react-intl';

class ComplianceEmailsFormVM extends BaseAccountAdminSettingViewModel {
    @mobx.observable
    public isFormChecked: boolean = false;
    @mobx.observable
    public complianceEmails: string;

    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);

        this.setComplianceEmails((this.entity.additionalData as string[]).join(','));
    }

    @mobx.action
    public setComplianceEmails = (emails: string): void => {
        this.complianceEmails = emails;
    };

    public getEmailsValidationMessage = (): string => {
        let validationMessage = '';
        const isFieldEmpty = !this.getComplianceEmailsToDTO().length || !this.complianceEmails.length;
        if (this.isFormChecked && isFieldEmpty) {
            validationMessage = this.intl.formatMessage(EMAIL_ADDRESSES_IS_REQUIRED);
        }
        const amountEmails = this.complianceEmails.split(',').length;
        if (amountEmails > COMPLINACE_EMAIL_MAX_EMAILS_AMOUNT) {
            validationMessage = this.intl.formatMessage(ENTER_MAXIMUM_TEN_EMAILS);
        }
        const isValidByEmails = emailListValidator(this.complianceEmails);
        if (!isValidByEmails.valid) {
            validationMessage = this.intl.formatMessage({
                description: 'Text label',
                ...isValidByEmails.validationMessage
            });
        }
        return validationMessage;
    };

    @mobx.action
    public setFieldTouched = (): void => {
        if (this.entity.enabled) this.isFormChecked = false;
    };

    public get notificationMessage(): MessageDescriptor {
        return COMPLIANCE_EMAIL_DATA_UPDATED as MessageDescriptor;
    }

    public async apiCall(): Promise<void> {
        const response = await this.accountAdminDAO.updateComplianceEmailsData({
            accountId: this.entity.accountId,
            type: this.entity.type,
            complianceEmailCaptureEnabled: this.entity.enabled,
            complianceEmails: this.entity.enabled
                ? this.getComplianceEmailsToDTO()
                : []
        });
        this.setComplianceEmails(response.complianceEmails.join(','));
        this.entity.setAdditionalData(response.complianceEmails);
    }

    protected shouldInterruptSubmit(): boolean {
        return super.shouldInterruptSubmit() || !this.isFormValid();
    }

    protected onInteruptHandler(): boolean | void {
        if (!this.isFormValid()) {
            this.isFormChecked = true;
        }
    }

    private isFormValid = (): boolean => {
        return !(this.entity.enabled && this.getEmailsValidationMessage());
    };

    private getComplianceEmailsToDTO = (): string[] => {
        return this.complianceEmails
            .split(',')
            .filter(Boolean)
            .reduce((result, current) => {
                if (!!current) result.push(current.trim());
                return result;
            }, []);
    };
};

export default ComplianceEmailsFormVM;
